module.exports = __webpack_public_path__ + "img/img_budget.4e3f9a84.png";